<template lang="pug">
div
  nav.navbar.is-dark
    .navbar-brand
      router-link.navbar-item.logo-image(:to="{ path: '/' }")
        img(src="/images/icons/icon-128x128.png")
      router-link.navbar-item(:to="{ path: '/' }")
        b.logo.is-size-4.is-size-5-mobile Blessing Others
      a.navbar-burger.burger(ref="burger" @click="toggleLinks" :class="{ 'is-active': showLinks }")
        span
        span
        span
    .navbar-menu(ref="links" :class="{ 'is-active': showLinks }")
      .navbar-start
        a.navbar-item(v-if="showManage" @click="managePosts") Manage
        .navbar-item.has-dropdown.is-hoverable
          a.navbar-link About
          .navbar-dropdown
            a.navbar-item(@click="welcome") Welcome
            a.navbar-item(@click="terms") Terms of Use
            a.navbar-item(@click="privacy") Privacy
      .navbar-end
        .navbar-item(v-if="authLoading")
          button.button.is-small.is-secondary.is-loading(@click="login")
            span Loading
        template(v-if="!authLoading")
          .navbar-item.has-dropdown.is-hoverable(v-if="user")
            a.navbar-link Account
            .navbar-dropdown.is-right
              .navbar-item {{ user.name }}
              a.navbar-item(@click="routeByName('account')") My Profile
              a.navbar-item(@click="logout") Logout
          .navbar-item(v-if="!user")
            a.button.is-small.is-secondary(@click="login")
              strong Login
          .navbar-item(v-if="!user")
            a.button.is-small.is-primary(@click="signup")
              strong Signup
</template>

<script>
export default {
  data () {
    return {
      showLinks: false
    }
  },
  computed: {
    authLoading () {
      return !this.$auth.completed
    },
    user () {
      return this.$auth.user
    },
    showManage () {
      return this.$auth.has('staff')
    }
  },
  methods: {
    login () {
      this.$auth.login()
    },
    signup () {
      this.$auth.signup()
    },
    logout () {
      this.$auth.logout()
    },
    routeByName (name) {
      this.$router.push({ name: name })
      this.showLinks = false
    },
    welcome () {
      this.routeByName('welcome')
    },
    terms () {
      this.routeByName('terms')
    },
    privacy () {
      this.routeByName('privacy')
    },
    managePosts () {
      this.routeByName('manage')
    },
    toggleLinks () {
      this.showLinks = !this.showLinks
    }
  }
}
</script>

<style scoped lang="scss">
</style>
